import React, { Component } from "react";
import { NavLink } from 'react-router-dom';
import Currency from "../components/component.currency";
import Language from "../components/component.language";
import moment from "moment";
import Global from '../globals/global';
import FooterDelMar from "../partials/partial.footer.delmar";
//if (typeof window === "undefined")  var window={}
const location = window.location;
var activestyle = {
    fontWeight: "bold",
    color: "orange"
};


export default class footer extends Global {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
        this.setmenuoptions();
        //this.forceUpdate()
    }

    render() {

        var disablepages = this.config().nofooterpages || ['travelagentmessage', 'mitmessage', 'bancomermessage'];


        const disable = disablepages.find(page => {
            return location.pathname.search(page) != -1;
        })
        if (disable) return null;


        if (this.config().brand == 'delmarboutiqueaccommodation') {
            return <FooterDelMar />
        }

        return (


            <footer className="revealed">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">

                            {this.config().brand == 'trafictours' || this.config().brand == 'totoura' || this.config().brand == 'sunexcursions' || this.config().brand == 'transat' || this.config().brand == 'turissimojamaica' || this.config().brand == 'turissimo' ?
                                <h3>{this.t("Need help?")}</h3>
                                : <h3>{this.t("Need help with experiences?")}</h3>}

                            {this.config().phone != '' ?
                                <a href={"tel:" + this.config().phone} id="phone" className="price_ph">+{this.config().phone} {/*this.t('from')*/} {this.t('USA')}</a>
                                : ''
                            }

                            {this.config().mexicophone ? <a href={"tel:" + this.config().mexicophone} id="phone">+{this.config().mexicophone} {/*this.t('from')*/} {'MEX'}</a> : null}

                            <a href={"mailto:" + this.config().email} id="email_footer">{this.config().email}</a>
                        </div>
                        <div className="col-md-3">
                            <h3>{this.t("About")}</h3>
                            <ul>
                                <li><NavLink to="/aboutus" activeStyle={activestyle} >{this.t("About us")}</NavLink></li>
                                <li><NavLink to="/privacy" activeStyle={activestyle} >{this.t("Privacy Policy")}</NavLink></li>
                                {this.config().brand == 'trafictours' || this.config().brand == 'totoura' || this.config().brand == 'sunexcursions' || this.config().brand == 'transat' || this.config().brand == 'turissimojamaica' || this.config().brand == 'turissimo' || this.config().brand == 'toorzy' ?
                                    <li><NavLink to="/cookies" activeStyle={activestyle} >{this.t("Cookies Policy")}</NavLink></li>
                                    : ''}

                                {this.config().myaccount ? <li><NavLink to="/myaccount" activeStyle={activestyle} >{this.t("Account")}</NavLink></li> : ''}
                                <li><NavLink to="/terms" activeStyle={activestyle} >{this.t("Terms and condition")}</NavLink></li>
                            </ul>
                        </div>
                        <div className="col-md-3">
                            <h3>{this.t("Discover")}</h3>
                            <ul>
                                {this.config().transfers ? <li><NavLink to="/transfers" activeStyle={activestyle} >{this.t("Transfers")}</NavLink></li> : ''}
                                {this.config().tours ? <li><NavLink to="/tours/1" activeStyle={activestyle} >{this.t("Tours")}</NavLink></li> : ''}
                                {this.config().wishlist ? <li><NavLink to="/wishlist" activeStyle={activestyle} >{this.t("Wishlist")}</NavLink></li> : ''}
                                {this.config().contact ? <li><NavLink to="/contact" activeStyle={activestyle} >{this.t("Contact")}</NavLink></li> : ''}
                            </ul>
                        </div>
                        <div className="col-md-2">
                            <h3>{this.t("Settings")}</h3>
                            <div className="styled-select">
                                <Language header={false} />
                            </div>
                            <div className="styled-select">
                                <Currency header={false} />
                            </div>
                        </div>
                    </div>{/* -- End row --*/}
                    <div className="row">
                        <div className="col-md-12">




                        {this.config().brand === 'trafictours'?<div id="social_footer">
                                <ul class="social-list">
                                    <li><a href="https://www.facebook.com/profile.php?id=61581291284951" target="_blank" class="facebook">
                                        <i class="fab fa-facebook-f"></i>
                                    </a></li>
                                    <li><a href="https://www.instagram.com/trafictours.dmc/" target="_blank" class="instagram">
                                        <i class="fab fa-instagram"></i>
                                    </a></li>
                                    <li>
                                  
                                  <a href="https://www.tiktok.com/@trafictours?_t=ZS-90AKItolQt6&_r=1" target="_blank" class="tiktok">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="24" height="24" fill="currentColor">
    <path d="M30.7 5.3A11.6 11.6 0 0 0 32 12a11.7 11.7 0 0 0 9 5V22a16 16 0 0 1-9-3v14a12 12 0 1 1-12-12c.4 0 .8 0 1.2.1V27a5 5 0 1 0 4 5V5.3h5.5Z"/>
  </svg>
</a>

                                    </li>
                                    <li><a href="https://www.tripadvisor.com.mx/Attraction_Review-g150807-d15747954-Reviews-Trafictours-Cancun_Yucatan_Peninsula.html" target="_blank" class="tripadvisor">
                                        <i class="fab fa-tripadvisor"></i>
                                    </a></li>

                                    {/*
    <li><a href="https://twitter.com/" target="_blank" class="twitter">
      <i class="fab fa-twitter"></i>
    </a></li>
     */}
                                </ul>
                            </div>:''}

                            <div id="social_footer_" style={{ textAlign: "center" }}>
                                {/*  <ul>
                                    <li><a href="#"><i className="icon-facebook"></i></a></li>
                                    <li><a href="#"><i className="icon-twitter"></i></a></li>
                                </ul>
                                */}

                                <p>{this.config().brandname} Experiences | <a href="https://mobilesail.com/" target="_blank" class="footer_pow">Powered by Mobile Sail</a></p>

                            </div>

                        </div>
                    </div>{/* -- End row  --*/}
                </div>{/* -- End container  --*/}



            </footer>

        );
    }
}

